"use client";

import dynamic from "next/dynamic";

import { useInterviewPopupStore } from "@/stores/useInterviewPopupStore";

// Loaded on demand: this popup pulls in `livekit-client`, which a static import
// would place in the shared chunk that every route downloads.
const EnhancedInterviewPopup = dynamic(
  () => import("./EnhancedInterviewPopup"),
  { ssr: false },
);

/**
 * Global wrapper for the interview popup that uses Zustand store.
 * Mount this once at the app root level to make the popup accessible from anywhere.
 */
export function GlobalInterviewPopup() {
  const {
    isOpen,
    interviewId,
    participantName,
    jumpToTimestamp,
    quoteText,
    closePopup,
  } = useInterviewPopupStore();

  if (!interviewId) {
    return null;
  }

  // Only key by interviewId - remount when switching interviews (necessary for fresh data)
  // Timestamp/quote changes are handled efficiently via useEffect (no remount needed)
  return (
    <EnhancedInterviewPopup
      key={interviewId}
      isOpen={isOpen}
      onClose={closePopup}
      interviewId={interviewId}
      participantName={participantName}
      jumpToTimestamp={jumpToTimestamp}
      quoteText={quoteText}
    />
  );
}
